import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  type OnInit,
} from '@angular/core';
import { SharedI18nModule } from '@bizzdesign/shared/i18n';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { MenuModule } from 'primeng/menu';
import { TranslateMenuItemsPipe } from '@bizzdesign/shared/pipes';
import { type BdAvatar } from '@bizzdesign/shared/utils';
import { UserAvatarDirective } from '@bizzdesign/shared/directives';
import { UserCardComponent } from '@bizzdesign/ui-user-card';
import { type BDMenuItem } from '@bizzdesign/shared/models';
import { ProductAnalyticsService } from '@bizzdesign/shared/services';

@Component({
  selector: 'bd-account-menu',
  imports: [
    AsyncPipe,
    NgTemplateOutlet,
    AvatarModule,
    ButtonModule,
    MenuModule,
    TooltipModule,
    SharedI18nModule,
    TranslateMenuItemsPipe,
    UserAvatarDirective,
    UserCardComponent,
  ],
  styleUrl: './account-menu.component.scss',
  templateUrl: './account-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountMenuComponent implements OnInit {
  private readonly productAnalyticsService = inject(ProductAnalyticsService);
  @Input() accountMenuItems: BDMenuItem[] = [];
  @Input() userAvatar: BdAvatar | null = null;
  @Input() isFirstToolbarItem = false;
  @Input() appendTo: string | undefined = undefined;

  expandIcon = true;

  ngOnInit(): void {
    if (
      !this.accountMenuItems.some(
        (accountMenuItem) => accountMenuItem.id === 'userAccountMenuItem',
      )
    ) {
      this.accountMenuItems.unshift({ id: 'userAccountMenuItem' });
    }
  }

  changeIcon(event: boolean) {
    this.expandIcon = event;
  }

  onMenuButtonClick(visible?: boolean): void {
    if (visible) {
      this.productAnalyticsService.sendEvent('account_menu_opened');
    }
  }
}
